import { usersActions } from '../ActionTypes';
import { updateState } from '../../middlewares/utils';

const initialFormData = {
  Id: '0',
  StudentName: '',
  MobileNumber: '',
  IsActive: '',
  EmailId: '',
  LoginId: '',
  Password: ''
};

const defaultState = {
  usersList: [],
  tableLoading: false,
  form: initialFormData,
  formLoading: false,
  formError: null,
  deleteId: null
};


export default (state = defaultState, actions) => {
  switch (actions.type) {
    case usersActions.USERS_FETCH_START:
      return updateState(state, { tableLoading: true });
    case usersActions.USERS_FETCH_SUCCESS:
      return updateState(state, { tableLoading: false, usersList: actions.payload });
    case usersActions.USERS_FETCH_ERROR:
      return updateState(state, { tableLoading: false, ...actions.payload });
    case usersActions.USERS_SAVE_START:
      return updateState(state, { formLoading: true, formError: null, form: initialFormData });
    case usersActions.USERS_SAVE_SUCCESS:
      return updateState(state, { formLoading: false, form: initialFormData });
    case usersActions.USERS_SAVE_FAILED:
      return updateState(state, { formLoading: false, ...actions.payload });
    case usersActions.USERS_SET_FORM:
      return updateState(state, { ...actions.payload, formError: null });
    case usersActions.USERS_RESET_FORM:
      return updateState(state, { form: initialFormData });
    default:
      return state;
  }
};
